import * as React from 'react';
export const wellsfargoSvg = React.forwardRef(function wellsfargoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#CD1309',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FF0',
        d: 'M27.85 15c0-.78-.09-1.45-.35-2.03-.35-.48-.96-.57-1.93-.57H23.4v2.88h.7c1.05 0 1.22-.29 1.22-1.73h.88v4.8h-.88c0-1.63-.17-2.01-1.22-2.01h-.7v2.5c0 .86.09.86.87.86h.96v1.16H19.9V19.7h.53c.7 0 .96-.1.96-.86v-5.68c0-.76-.27-.86-.96-.86h-.53v-1.06h8.92V15h-.96zm-9.15-3.76-.06 1.16h-.09c-.78 0-.96.28-1.3 1.15l-2.45 7.3h-1.58l-2-5.28-1.93 5.29H7.7l-2.6-7.21c-.26-.87-.78-1.25-1.4-1.25h-.17v-1.16H7.9v1.16h-.35c-.52 0-.78.1-.7.38 0 .1-.08.2 0 .3 0 0 1.05 2.68 1.84 5.28h.09l1.75-4.8c-.1-.78-.35-1.16-1.05-1.16h-.62v-1.16h4.64v1.16h-.7c-.44 0-.62.1-.62.38 0 .1 0 .2.1.39 0 0 1.04 2.79 1.83 5.19h.09l1.66-4.8c.08-.4.08-.59.08-.78 0-.29-.17-.38-.7-.38h-.6v-1.16h4.07z',
      }),
    ),
  );
});
wellsfargoSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var wellsfargo = {
  category: 'brand',
  colorable: false,
  name: 'wellsfargo',
  svg: wellsfargoSvg,
};
